import { message } from "antd";
import utils from "./utils";
import REST from "./RESTApi";
import searchExample from "./json/searchExample.json";

/**
 * @namespace 项目级通用方法
 */
const common = {
    /**
     * 项目针对特定接口，配置REST post方法的header
     * @param {*} axiosConfig 
     */
    setPostParams: function(axiosConfig, originUrl) {
        let largerTimeLimitUrls = [
            "/project/gsm", "/project/addGse"
        ];
        if (utils.contain(largerTimeLimitUrls, originUrl)) {
            axiosConfig["params"] = {"_timeout": "30000"};
        }
    },
    /**
     * 根据GSE号，设置储存在localStorage中的albumn信息
     * @param {*} gse 
     * @param {*} albumnList 
     */
    setLocalAlbumns: function (gse, albumnList) {
        let localAlbumnIds = localStorage.getItem("albumIds") ? JSON.parse(localStorage.getItem("albumIds")) : {};
        localAlbumnIds[gse] = utils.extractValueFromObjectArrayByKey(albumnList, "id");
        localStorage.setItem("albumIds", JSON.stringify(localAlbumnIds));
    },
    /**
     * 根据GSE号，获取储存在localStorage中的albumn信息
     * @param {*} gse 
     */
    getLocalAlbumns: function (gse) {
        let localAlbumnIds = localStorage.getItem("albumIds") ? JSON.parse(localStorage.getItem("albumIds")) : {};
        return localAlbumnIds[gse];
    },
    /**
     * 将一个albumId添加到本地储存
     * @param {*} gse 
     * @param {*} albumId 
     */
    addAlbumIdToLocal: function (gse, albumId) {
        let localAlbumnIds = localStorage.getItem("albumIds") ? JSON.parse(localStorage.getItem("albumIds")) : {};
        if (!localAlbumnIds[gse]) {
            localAlbumnIds[gse] = [albumId];
        } else {
            localAlbumnIds[gse].push(albumId);
        }
        localStorage.setItem("albumIds", JSON.stringify(localAlbumnIds));
    },
    /**
     * 从本地存储中删除一个albumId
     * @param {*} gse 
     * @param {*} albumId 
     */
    deleteAlbumIdFromLocal: function (gse, albumId) {
        let localAlbumnIds = localStorage.getItem("albumIds") ? JSON.parse(localStorage.getItem("albumIds")) : {};
        localAlbumnIds[gse] = localAlbumnIds[gse].filter((value, index) => {
            return value != albumId
        });
        localStorage.setItem("albumIds", JSON.stringify(localAlbumnIds));
    },
    /**
     * 获取所有储存在本地的AlbumId，不分GSE
     */
    getAllLocalAlbumIds: function () {
        let localAlbumnIds = localStorage.getItem("albumIds") ? JSON.parse(localStorage.getItem("albumIds")) : {};
        let allAlbumIds = [];
        Object.values(localAlbumnIds).forEach((idList) => {
            allAlbumIds.concat(idList);
        });
        return allAlbumIds;
    },
    /**
     * 未登录状态下将一系列GSE号添加到购物车
     * （其实就是保存在localstorage里了）
     *  @param {Array} gseList
     */
    unLoginAddToCart: function (gseList) {
        if (gseList.length == 0) {
            return;
        }
        let localCartGSEList = localStorage.getItem("unLoginCart") ? JSON.parse(localStorage.getItem("unLoginCart")) : [];
        localStorage.setItem("unLoginCart", JSON.stringify(utils.uniqueArray(gseList.concat(localCartGSEList))));
        message.success("Successfully added to cart")
    },
    /**
     * 未登录状态下将一系列GSE号从购物车中移除
     * @param {Array} gseList 
     */
    unLoginRemoveCart: function (gseList) {
        let localCartGSEList = localStorage.getItem("unLoginCart") ? JSON.parse(localStorage.getItem("unLoginCart")) : [];
        let newGSEList = [];
        localCartGSEList.forEach((gse, index) => {
            if (!utils.contain(gseList, gse)) {
                newGSEList.push(gse);
            }
        });
        localStorage.setItem("unLoginCart", JSON.stringify(newGSEList));
    },
    /**
     * 未登录状态下移除所有购物车内容
     */
    unLoginClearCart: function () {
        localStorage.removeItem("unLoginCart");
    },
    /**
     * 未登录状态获取购物车中的GSE号
     */
    unLoginGetCart: function () {
        return JSON.parse(localStorage.getItem("unLoginCart")) || [];
    },
    /**
     * 未登录状态获取当前电脑存储的project号
     */
    unLoginGetProjects: function () {
        return JSON.parse(localStorage.getItem("projects")) || [];
    },
    /**
     *  未登录状态下将新projectId储存在本地
     * @param {*} projectId 
     */
    unLoginAddProject: function (projectId) {
        let localProjectIds = localStorage.getItem("projects") ? JSON.parse(localStorage.getItem("projects")) : [];
        localProjectIds.push(projectId);
        localStorage.setItem("projects", JSON.stringify(localProjectIds));
    },
    /**
     * 未登录状态下删除一系列projectId
     * @param {*} projectIds 
     */
    unLoginDeleteProject: function (projectIds) {
        let localProjectIds = localStorage.getItem("projects") ? JSON.parse(localStorage.getItem("projects")) : [];
        let newProjectIds = [];
        localProjectIds.forEach((id, index) => {
            if (!utils.contain(projectIds, id)) {
                newProjectIds.push(id);
            }
        });
        localStorage.setItem("projects", JSON.stringify(newProjectIds));
    },
    /**
     * 未登录状态下设置某个页面的初次教程已完成
     * @param {*} tourName 
     */
    unLoginSetTourFinished: function(tourName) {
        let localFinishedTours = localStorage.getItem("finisheTours") ? JSON.parse(localStorage.getItem("finisheTours")) : [];
        if (!utils.contain(localFinishedTours, tourName)) {
            localFinishedTours.push(tourName);
        }
        localStorage.setItem("finisheTours", JSON.stringify(localFinishedTours));
    },
    /**
     * 未登录状态下检查某个教程是否已完成
     * @param {*} tourName 
     */
    unLoginCheckFinishedTour: function(tourName) {
        let localFinishedTours = localStorage.getItem("finisheTours") ? JSON.parse(localStorage.getItem("finisheTours")) : [];
        return utils.contain(localFinishedTours, tourName);
    },
    /**
     * 创建默认Project
     */
    createDefaultProject: function(cbFun) {
        let url = "/project/add";
        let params = {
            name: "Default project",
            description: ""
        };
        REST.post(url, params).then(res => {
            common.unLoginAddProject(res.data);
            cbFun && cbFun();
        })
    },
    /**
     * 创建Demo project
     */
    createDemoProject: function(cbFun) {
        let url = "/project/add";
        let params = {
            name: "Demo project",
            description: "This demo project focuses on a succinct gene expression analysis in uveal melanoma. Utilizing advanced bioinformatics, it seeks to uncover genetic variations linked to tumor progression and identify potential biomarkers. This approach is expected to enhance understanding of the molecular dynamics of the disease and aid in developing targeted treatments."
        };
        REST.post(url, params).then(res => {
            common.unLoginAddProject(res.data);
            let url2 = "/project/addGse";
            let params2 = {
                id: res.data,
                gseAcc: searchExample.text.split(",")
            }
            REST.post(url2, params2).then(res2 => {
                cbFun && cbFun();
            })
        })
    },
    /**
     * 初次进入时初始化项目
     */
    initProject: function() {
        let hasInit = localStorage.getItem("hasInit"); // 判断下是否已创建过初始项目
        if (!hasInit) {
            // common.createDefaultProject(() => {
            //     common.createDemoProject(() => {
            //         localStorage.setItem("hasInit", true);
            //     })
            // })
            common.createDemoProject(() => {
                localStorage.setItem("hasInit", true);
            })
        }
    }
};

export default common;